import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {AuthService} from "../_services/auth.service";
import {filter, from, map, Observable, switchMap, take} from "rxjs";

export const raaNoAccessGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    return authService.getUser().pipe(
        filter(user => !!user),
        take(1),
        switchMap(user => from(authService.getDynamicSettings()).pipe(
            map(settings => {
                if (settings.is_raa && user.role.role_type === 'young_person' && user.role.name != 'Adult (18+)') {
                    return router.createUrlTree(['/noBoxes']);
                }
                return true;
            })
        ))
    );
}
